/* globals window */
import PromisePolyfill from './promise/promise'
import mountRedraw from './mount-redraw'
import request from './request/request'
export default request(window, PromisePolyfill, mountRedraw.redraw)
